import * as React from 'react';
import {Project, MessProject} from './api-client/index';
import {Messung} from './api-client/models/Messung';
import {Reflektometer}  from './api-client/models/Reflektometer';
import { EXChartComponentProps } from './components/EXChartComponent';
import {ServiceInfo} from './api-client/index';


export interface Session {
  user: {
    name?: string;
    email?: string;
    image?: string;
  };
  measurement?: any;
  project?: Project;
  current_messproject?: MessProject;
  current_configuration?: any; // Added current_configuration to session
  current_reflektometer?: Reflektometer; // Added current_reflektometer to session
  current_sensor?: any; // Added current_sensor to session
  current_project?: Project; // Added current_project to session
  chart_data?: any; // Added chart_data to session
  measurement_data?: any; // Added measurement_data to session such as xLength xStart
  obr_data?: any; // Added obr_data to session
  align_date?: Date; // Added align_date to session
  calibration_date?: Date; // Added calibration_date to session
  obr_session_id ?: string; // Added obr_session_id to session would be set when the user selects a differrent OBR
  x_api_key ?: string; // Added x_api_key to session would be set when the user selects a differrent OBR
  token?: string; // Added token to session for authentication
  is_admin?: boolean; // Added is_admin to session for role-based access control
  language?: string; // Added language to session for i18n
  loglevel?: 'debug' | 'info' | 'warn' | 'error'; // Added loglevel to session for dynamic logging control
  chart_props?: EXChartComponentProps; // Added chart_props to session for passing props to charts
  chart_strain_data?: any; // Added chart_strain_data to session for passing strain chart data to charts  
  gage?: number; // Added gage to session for passing gage value to charts
  sensorSpacing?: number; // Added sensorSpacing to session for passing sensor spacing value to charts
  reference_messung?: Messung;
  sensorReferenceMessungMap?: Record<string, string>; // Maps sensor_id to the last selected reference Messung id
  loading?: boolean; // Added loading to session for indicating loading state across the app
  current_sensor_id?: any; // Added current_sensor to session
  current_messung_id?: any; // Added current_messung to session
  services?: Array<ServiceInfo>; // Added services to session for storing server sync services
  trigger_sync_check?: boolean; // Added trigger_sync_check to session to indicate if a sync check should be triggered
}

interface SessionContextType {
  session: Session | null;
  setSession: (session: Session | null) => void;
  loading: boolean;
}

export const defaultSession: Session = {
  user: {
    name: 'Matthias Vitt',
    email: 'matthias.vitt@gmail.com'
  },
  measurement: undefined,
  project: undefined,
  current_messproject: undefined,
  current_configuration: undefined,
  current_sensor: undefined,
  chart_data: undefined,
  measurement_data: undefined,
  obr_data: undefined,
  align_date: undefined,
  calibration_date: undefined,
  obr_session_id: "dev:LUNA_OBR_4600",
  current_reflektometer: undefined,
  x_api_key: undefined,
  token: undefined,
  language: 'en', // Default language
  chart_props: undefined, // Added chart_props to session for passing props to charts
  current_project: undefined, // Added current_project to session
  loglevel: 'info',
  chart_strain_data: undefined,
  gage: undefined, // Added gage to session for passing gage value to charts
  sensorSpacing: undefined, // Added sensorSpacing to session for passing sensor spacing value to charts
  reference_messung: undefined,
  sensorReferenceMessungMap: {},
  loading: false, // Added loading to session for indicating loading state across the app
  current_sensor_id: undefined,
  current_messung_id: undefined,
  services: undefined,
  trigger_sync_check: false,
};

const SessionContext = React.createContext<SessionContextType>({
  session: defaultSession,
  setSession: () => {},
  loading: true,
});

export default SessionContext;

export const useSession = () => React.useContext(SessionContext);